import { isNil } from 'lodash';
import { useCallback, useId } from 'react';
import { Icon } from '@shared/components/Icon';
import { View } from '@shared/components/View';
import { Pill } from '@shared/components/pill';
import { TruncateMiddle } from '@shared/components/truncate';
import { getAnchorName, grid } from '@shared/styles';
import { FileUpload } from '@shared/types/fieldValues';
import { openLink } from '@shared/util/link';
import { getFilenameParts } from '@shared/util/media/type';
import classNames from './FileItem.module.css';

interface Props {
  file: FileUpload;
  editable: boolean;
  showFileIcon?: boolean;
  onClear?: () => void;
}

export function FileItem({ file, onClear, editable, showFileIcon = true }: Props) {
  const id = useId();
  const viewTransitionName = getAnchorName('file-item', id);
  const openFile = useCallback(() => openLink(file.url), [file.url]);
  const [filename, extension] = getFilenameParts(file.name);
  const end = extension ? `.${extension}` : undefined;

  if (isNil(file)) {
    return null;
  }

  return (
    <View
      className={classNames.fileItem}
      style={{ '--view-transition-name': viewTransitionName }}
      tooltip={file.name}
    >
      <Pill
        noLeftMargin
        onPress={openFile}
        onRemove={editable ? onClear : undefined}
        maxWidth={grid(30)}
      >
        {showFileIcon && <Icon name="file" gridSize={3} className={classNames.fileIcon} />}
        <TruncateMiddle beginning={filename} end={end} />
      </Pill>
    </View>
  );
}
